import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, ElementRef, afterNextRender } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers/adobe-analytics.service';
import { AuthenticationService } from 'lib/ng2-sapmp/src/providers/authentication.service';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import { HeaderService } from '../header/header.service';
import { BreadCrumbService } from "lib/ng2-sapmp/src/ui-components/breadcrumb";
import { HomeService } from '../home/shared/providers/home.service';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { HostListener } from '@angular/core';
import { ViewChild } from '@angular/core';
import { HomeComponent, HOME_DATA } from '../home';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { MDMDetails } from './../../models/product';
import { ADDP_PERMISSION_MAPPING, LOGIN_ERROR } from 'config';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import {Subscription} from "rxjs"
import { url } from 'inspector';
import { Subject, interval } from 'rxjs';
import { takeUntil, distinctUntilChanged, filter, timeout, take } from 'rxjs/operators';

declare var PREMIER_LOGIN_URL: any;
declare var MYATT_LOGIN_URL: any;
declare var FIRSTNET_LOCAL_CONTROL_URL: any;
declare var ENV_PORTAL: any;
@Component({
  selector: 'app-menus',
  providers: [HomeService],
  templateUrl: './menus.component.html',
  styleUrls: ['./menus.component.scss']
})
export class MenusComponent implements OnInit {
  public triggerUrl: any;
  public pageContent: any;
  public openDropMenu: boolean = true;
  public closeDropMenu: boolean = false;
  public display: boolean = false;
  public hideMeuImg: boolean = false;
  public showMenuImg: boolean = true;
  public commonLoginContainer: boolean = false;
  public sticky: boolean = false;
  public elementPosition: any;
  @ViewChild('stickyMenu') menuElement: ElementRef;
  public landingPageRoute: string;
  public homePage: any;
  public user: UserProfileModel;
  public mdmDetails: MDMDetails;
  public redirectFlag: boolean = false;
  public loginFlag: boolean;
  public loginErrorMessage: string;
  public pageSlider: any;
  public pageCount = 0;
  public mobile: boolean = true;
  public isNotDMPAdmin: boolean = true;
  public isNotSelectStubId: boolean = true;
  public clickEventSub: Subscription;
  public show5gOption : boolean = true;
  public menuHideEvent: Subscription;
  public enrollStatusSubscription: Subscription;
  public accountStatusSubscription: Subscription;
  showRegisterIcon: boolean = true;
  showDevicesIcon: boolean = true;
  private destroy$ = new Subject<void>();
  private iconsPollSub: Subscription;
  
  
  constructor(private headerService: HeaderService, private route: ActivatedRoute, private router: Router, private el: ElementRef,
    private authenticationService: AuthenticationService, private chips: ChipsService, private adobeAnalyticsService: AdobeAnalyticsService,
    private homeService: HomeService, private utilityService: UtilityService, private pageloaderService: PageLoaderService, private breadCrumbService: BreadCrumbService,
  ) {
    if(ENV_PORTAL !== "dmpadmin"){
      this.headerService.pageContent(ENV_PORTAL).subscribe((res: HttpResponse<any>) => {
        this.pageContent = res[ENV_PORTAL].header;
        sessionStorage.setItem('loginDropdownPopupSwitch', this.pageContent.loginDropdownPopup);
      });  
    }
    

    this.user = new UserProfileModel();
    this.homePage = HOME_DATA;
    this.mdmDetails = new MDMDetails();
    this.loginFlag = false;

    // afterNextRender(() =>{
    //     let accountSummaryData = sessionStorage.getItem('accountSummaryData') ? JSON.parse(sessionStorage.getItem('accountSummaryData')) : null;
    //     if(accountSummaryData && accountSummaryData.allFansInEligible) {
    //       console.log('accountSummarydata called 1');
    //       this.showRegisterIcon = false;
    //       this.showDevicesIcon = false;
    //     }
    // });

    // this.showIconsDynamically();
    // afterNextRender(() => {
    //     this.showIconsDynamically();
    // });
    // sessionStorage.setItem("allFansInEligible", "false");
  }

  learnRouteActive() {
    
    // Forcing route active to return false for US-1367
    // // if (this.router.url == '/productselection' || this.router.url == '/welcome' || this.router.url == '/signupsetup/enrollmentoptions' || this.router.url == '/signupsetup/review' || this.router.url == '/signupsetup/confirm') {
    // //   this.removeActive();
    // //   let navlist = document.querySelectorAll('.has-subnav');
    // //   navlist[1].classList.add('active');
    // //   return false;
    // // }
    // // else 
    // if(this.router.url == '/learn/products' || this.router.url == '/learn/applebusinessmanager' || this.router.url == '/learn/androidzerotouch' || this.router.url == '/learn/samsungknoxmobile' || this.router.url == '/learn/5g'){
    //   // this.removeActive();
    //   // let navlist = document.querySelectorAll('.has-subnav');
    //   // navlist[1].classList.remove('active');
    //   return true;
    // }else{
    //   return false;
    // }
    return false;
  }

  supportsRouteActive(){
    if(this.router.url == '/support' || this.router.url == '/contact'){
      // this.removeActive();
      // let navlist = document.querySelectorAll('.has-subnav');
      // navlist[6].classList.add('active');
      return true;
    }else{
      return false;
    }
  }

  enrollRouteActive(){
    if (this.router.url == '/productselection' || this.router.url == '/welcome' || this.router.url == '/signupsetup/enrollmentoptions' || this.router.url == '/signupsetup/review' || this.router.url == '/signupsetup/confirm' || this.router.url == '/productselection/enrollmentoptions'|| this.router.url == '/productselection/review' || this.router.url == '/productselection/confirm') {
      // this.removeActive();
      // let navlist = document.querySelectorAll('.has-subnav');
      // navlist[1].classList.add('active');
      return true;
    }else{
      return false;
    }
  }

  removeActive(){
    let navlist = document.querySelectorAll('.has-subnav');
    navlist.forEach((element) => {
      element.classList.remove('active');
    })
  }

  homeRouteActive() {
    if (this.router.url == '/home') {
      let navlist = document.querySelectorAll('.has-subnav');
      navlist[1].classList.remove('active');
      navlist[3].classList.remove('active');
      return this.router.url == '/home';
    }else{
      return false;
    }
    // else if (this.router.url == '/learn/products' || this.router.url == '/learn/applebusinessmanager' || this.router.url == '/learn/androidzerotouch' || this.router.url == '/learn/samsungknoxmobile') {
    //   let navlist = document.querySelectorAll('.has-subnav');
    //   navlist[3].classList.add('active');
    // }
    // else if (this.router.url == '/productselection' || this.router.url == '/welcome') {
    //   let navlist = document.querySelectorAll('.has-subnav');
    //   navlist[1].classList.add('active');
    // }
  }

  ngOnInit() {
    this.clickEventSub = this.headerService.getEnrollClickEvent().subscribe((resp)=>{
      if(resp){
        this.navigateDeviceAndShop();
      }
      console.log('URL: ' + this.router.url);
      
    });

    if (ENV_PORTAL === "dmpadmin" ) {
      this.isNotDMPAdmin = false;
      // if(window.location.href.indexOf("care") == -1){
      //   //customer portal under admin
      //   this.isNotDMPAdmin = true;
      // }else{
      //   //normal admin portal
      //   this.isNotDMPAdmin = false;
      // }
      
    }
    if(ENV_PORTAL === "fnabc" || ENV_PORTAL === "myatt") {
      this.show5gOption = false;
    }
    this.pageSlider = this.utilityService.getEnvConfig().homePageCms;
    this.landingPageRoute = this.authenticationService.getLandingPageRoute();
    //code for login error banner
    const status = localStorage.getItem('loginFail');
    if (status) {
      localStorage.removeItem('loginFail');
      this.loginErrorMessage = (LOGIN_ERROR[status]) ?
        LOGIN_ERROR[status] :
        LOGIN_ERROR['403'];
    }
    this.homeService.getSlider(this.pageSlider)
      .subscribe((respobj) => {
        this.homePage = respobj;
        this.pageCount = respobj.slider.length;
      }, error => {
        this.handleError(error);
      });
    this.homeService.createPageLoadProperties();

    this.enrollStatusSubscription = this.authenticationService.getEnrollStatus().subscribe(status => {
      console.log("Enroll Status1: " + status);
      this.showRegisterIcon = status;
      // Perform any additional actions needed when enrollStatus changes
    });

     this.iconsPollSub = interval(2000)
      .pipe(
        filter(() => {
          const raw = sessionStorage.getItem('accountSummaryData');
          return raw !== null && raw !== undefined;
        }),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.showIconsDynamically();
      });
  }

  showIconsDynamically(){
    console.log("calling dynamically show icons..");
      let accountSummaryData = sessionStorage.getItem('accountSummaryData') ? JSON.parse(sessionStorage.getItem('accountSummaryData')) : null;
      if(accountSummaryData && accountSummaryData.allFansInEligible) {
        console.log('accountSummarydata called 3');
        this.showRegisterIcon = false;
        this.showDevicesIcon = false;
        sessionStorage.setItem("allFansInEligible", "true");
      }else{
        sessionStorage.setItem("allFansInEligible", "false");
      }
  }

  

  handleError(error) {
    throw error;
  }

  over() {
    this.showMenuImg = false;
    this.hideMeuImg = true;
  }
  out() {
    this.showMenuImg = true;
    this.hideMeuImg = false;
    this.openDropMenu = true;
    this.closeDropMenu = false;
    this.display = false;
  }
  setRKey(parameter) {
    this.triggerUrl = parameter === 'myatt' ? MYATT_LOGIN_URL : PREMIER_LOGIN_URL;
    window.location.href = this.triggerUrl;
  }

  setCallingPage(callingPageUrl) {
    sessionStorage.setItem('callingPageName', callingPageUrl);
  }

  ngAfterViewInit() {
    this.elementPosition = 10;
    this.enrollStatusSubscription = this.authenticationService.getEnrollStatus().subscribe(status => {
      console.log("Enroll Status2: " + status);
      // Perform any additional actions needed when enrollStatus changes
    });

    // setTimeout(() =>{
    //     let accountSummaryData = sessionStorage.getItem('accountSummaryData') ? JSON.parse(sessionStorage.getItem('accountSummaryData')) : null;
    //     if(accountSummaryData && accountSummaryData.allFansInEligible) {
    //       console.log('accountSummarydata called 2');
    //       this.showRegisterIcon = false;
    //       this.showDevicesIcon = false;
    //     }
    // }, 1000);
 }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    this.ngAfterViewInit();
    if (windowScroll > this.elementPosition) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }
  }


  openCloseSubMenu(id) {
    if (id === "show") {
      this.display = true;
      this.openDropMenu = false;
      this.closeDropMenu = true;
    } else if (id === "hide") {
      this.display = false;
      this.openDropMenu = true;
      this.closeDropMenu = false;
    }
    if (id === "showMenu") {
      this.showMenuImg = false;
      this.hideMeuImg = true;
    }
    else if (id === "hideMenu") {
      this.showMenuImg = true;
      this.hideMeuImg = false;
      this.out();
      document.getElementById("openRight").classList.add('disable-hover');
      setTimeout(() => {
        document.getElementById("openRight").classList.remove('disable-hover')
      }, 40);
    }
  }

  checkSlider(buttonLink, title) {
    let navlist = document.querySelectorAll('.has-subnav');

    navlist[0].classList.remove('active');
    if ((buttonLink === "/learn/androidzerotouch") || (buttonLink === "/learn/applebusinessmanager") || (buttonLink === "/learn/samsungknoxmobile") || (buttonLink === "/learn/5g")) {
      navlist[3].classList.add('active');
    }
    if (buttonLink.startsWith('http')) {
      this.adobeAnalyticsService.createClickProperties('Learn more about ' + title, 'Body', buttonLink);
      window.open(buttonLink);
    }
    else {
      this.adobeAnalyticsService.createClickProperties('Learn more about ' + title, 'Body', '/businessconsole' + buttonLink);
      return this.router.navigate([buttonLink]);
    }
  }

  commonFunction(funcName, parameter) {
    if (location.href.indexOf('selectstubid') != -1 && (parameter == "/support" || parameter == "/faq" || parameter =="/learn")) {
      alert('Please select a StubID to proceed.');
    } else {
    let navlist = document.querySelectorAll('.has-subnav');
    navlist[0].classList.remove('active');
    navlist[1].classList.remove('active');
    if (parameter == "/home") {
      navlist[3].classList.remove('active');
      navlist[1].classList.remove('active');
      this.chips.setChips(undefined);
      this.breadCrumbService.setCurrentBreadCrumb(undefined);
    }
    else if (parameter === "/learn") {
      let loginSwitch = JSON.parse(sessionStorage.getItem('loginDropdownPopupSwitch'));
      if(sessionStorage.getItem('sapmp_jwtToken') === null){
        if(loginSwitch){
          this.authenticationService.setLoginModalStatus(true);
        }else{
          this.authenticationService.loginDirect("fnabc");
        }
        this.authenticationService.setLoginSuccessUrl("/home");
        localStorage.setItem("navigateFrom", "enroll");
        let d = new Date();
        d.setTime(d.getTime() + (90*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie="enroll=true; expires="+expires+"; domain=.att.com; path=/";
      }else{
        navlist[1].classList.add('active');
        navlist[3].classList.remove('active');
        this.navigateDeviceAndShop();
      }
    }
    else {
      navlist[1].classList.remove('active');
      navlist[3].classList.remove('active');
    }
    if (funcName == "setRKey") {
      this.setRKey(parameter);
    }
    else if (funcName == "setCallingPage") {
      this.setCallingPage(parameter);
    }
    else if (funcName == "localControl") {
      window.open(FIRSTNET_LOCAL_CONTROL_URL);
    }
    else if (funcName == 'action') {
      window['store'].dispatch({ type: parameter });
    }
  }
}

  navigateDeviceAndShop() {
    let navlist = document.querySelectorAll('.has-subnav');
    if(navlist && navlist.length > 0){
      navlist[0].classList.remove('active');
      navlist[1].classList.add('active');
    }
    
    this.pageloaderService.setPageLoaderStatus(false);
    let processingFans = JSON.parse(sessionStorage.getItem('processingFanList'));
    let processingFansCount = JSON.parse(sessionStorage.getItem('processingFanList')) ? processingFans.length : 0;
    if (sessionStorage.getItem('sapmp_jwtToken') === null) {
      sessionStorage.setItem('eligibilityCheck', 'true');
      this.landingPageRoute = this.homePage.links[0].rlink;
      this.adobeAnalyticsService.createClickProperties(this.homePage.links[0].linkName, 'Body', '/businessconsole' + this.landingPageRoute);
      if(navlist && navlist.length > 0) {
        navlist[1].classList.remove('active');
      }
      return this.router.navigate([this.landingPageRoute]);
    }
    this.user = this.authenticationService.getUser();
    if (this.user.addpAuthority !== 'NONE') {
      this.authenticationService.getFanSignedUpStatus()
        .subscribe(resp => {
          sessionStorage.setItem("accountSummaryData", JSON.stringify(resp));
          sessionStorage.setItem('initialSignupStatus', resp.initialSignupStatus);
          sessionStorage.setItem('noOfDevice', resp.noOfDevices);
          if (resp.fansSummary?.length > 0) {
            let signupFanSum = resp.fansSummary;
            let signupFanList = [];
            let signupActiveFanList = [];
            let processingFanList = [];
            let inProgressFan = [];
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "AWAITING_SIGNUP") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  signupFanList.push(signupFanSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('signupFanList', JSON.stringify(signupFanList));

            //get active fans list
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "ACTIVE") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  signupActiveFanList.push(signupFanSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('signupActiveFanList', JSON.stringify(signupActiveFanList));
            //for 'processing' fans
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "PROCESSING") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  //processingFanList.push(signupFanSum[i].fans[j]);
                  inProgressFan.push(signupFanSum[i].fans[j]);
                  //getting fan info of 'processing' fan to store in session storage
                  for (let k = 0; k < resp.fanInfoList.length; k++) {
                    if (signupFanSum[i].fans[j] === resp.fanInfoList[k].fan) {
                      processingFanList.push(resp.fanInfoList[k]);
                    }
                  }
                }
              }
            }
            sessionStorage.setItem('inProgressFan', JSON.stringify(inProgressFan));
            sessionStorage.setItem('processingFanList', JSON.stringify(processingFanList));
          }
          if (!resp.efotaFansSummary) {
            sessionStorage.setItem('efotaEnrolledFanList', '[]');
          }
          else {
            let efotaFansSum = resp.efotaFansSummary;
            let efotaEnrolledFanList = [];
            for (let i = 0; i < efotaFansSum.length; i++) {
              if (efotaFansSum[i].status == "ACTIVE") {
                for (let j = 0; j < efotaFansSum[i].count; j++) {
                  efotaEnrolledFanList.push(efotaFansSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('efotaEnrolledFanList', JSON.stringify(efotaEnrolledFanList));
          }
          if (!resp.efotaNotEnrolledFanList) {
            sessionStorage.setItem('efotaNotEnrolledFanList', '[]');
            sessionStorage.setItem('efotaEnrollmentInfo', '[]');
          }
          else {
            sessionStorage.setItem('efotaEnrollmentInfo', JSON.stringify(resp.efotaEnrollmentInfo));
            sessionStorage.setItem('efotaNotEnrolledFanList', JSON.stringify(resp.efotaNotEnrolledFanList));
          }

          if (resp.allFansInEligible === true) {
            this.user.fanSignedUpStatus = 'NotEligible';
          } else {
            if (this.user) {
              this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
            }
            if (resp.productCode !== null && resp.productCode !== undefined) {
              this.mdmDetails.productCode = resp.productCode;
              this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
              if (this.mdmDetails.productCode === 'ADDPMDM') {
                this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
                let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                productDetails.emmProductCode = 'ADDPMDM';
                productDetails.selectedAccID = resp.ibmEmmAccountId;
                productDetails.signupEmmStatus = 'revised';
                sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
              } else {
                if (resp.googleEmmAccountId !== null && resp.googleEmmAccountId !== undefined) {
                  this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
                }
                if (resp.samsungEmmAccountId !== null && resp.samsungEmmAccountId !== undefined) {
                  this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
                }
                if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
                  sessionStorage.setItem('fanInfoList', JSON.stringify(resp.fanInfoList));
                }
              }
              sessionStorage.setItem('mdmDetails', JSON.stringify(this.mdmDetails));
            }
          }
          this.authenticationService.setUser(this.user);

          let checkMore = true;
          let directWelcome = false;
          if (resp.fansSummary) {
            for (let k = 0; k < resp.fansSummary.length; k++) {
              if (resp.fansSummary[k].status === "AWAITING_SIGNUP" && resp.fansSummary[k].count > 0) {
                this.redirectFlag = true;
                checkMore = false;
                if (resp.fansSummary[k].count === resp.noOfFans) {
                  directWelcome = true;
                }
              }
            }
          }

          if (resp.fanInfoList) {
            let fanArr = resp.fanInfoList.map((x) => x.fan);
            let fanArrRefine = [];
            if (fanArr && fanArr.length > 0) {
              fanArrRefine = fanArr.filter(
                (x, index) => fanArr.indexOf(x) === index
              );
            }

            let activeFanArr = resp.fanInfoList.filter((x) => x.accountStatus === "ACTIVE" || x.accountStatus === "SIGNUP_INPROGRESS");
            if (activeFanArr.length === 0) {
              directWelcome = true;
            }

            if (activeFanArr.length < fanArrRefine.length * 3) {
              this.redirectFlag = true;
            }
          }

          if (directWelcome === true) {
            this.router.navigate(['/welcome']);
            if(navlist && navlist.length > 0) navlist[1].classList.add('active');
            this.pageloaderService.setPageLoaderStatus(true);

          } else if (((this.homePage.links[0].rlink === '/learn') && (processingFansCount >= 1)) || this.redirectFlag) {
            this.router.navigate(['/productselection']);
            if(navlist && navlist.length > 0) navlist[1].classList.add('active');
            this.pageloaderService.setPageLoaderStatus(true);
          } else {
            this.pageloaderService.setPageLoaderStatus(true);
            return this.navigationRedirect(this.homePage.links[0].linkName);
          }
        }, () => {
          this.user.fanSignedUpStatus = 'Error';
          this.authenticationService.setUser(this.user);
          return this.navigationRedirect(this.homePage.links[0].linkName);
        });
    } else {
      return this.navigationRedirect(this.homePage.links[0].linkName);
    }
  }

  navigationRedirect(inputLinkName) {
    const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
    const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
    this.pageloaderService.setPageLoaderStatus(true);
    if (redirectInfo && this.mdmDetails.productCode === 'ADDPMDM' && redirectInfo.logonurl === 'productselection') {
      redirectInfo.logonurl = 'signup';
      this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
    } else if (redirectInfo) {
      this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
    }
    this.adobeAnalyticsService.createClickProperties(inputLinkName, 'Body', '/businessconsole' + this.landingPageRoute);
    this.landingPageRoute = this.authenticationService.getLandingPageRoute();
    this.router.navigate([this.landingPageRoute]);
  }


  getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'AWAITING_SIGNUP'; }).length;
      const abmfePendingSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'SIGNUP_INPROGRESS' }).length;
      if (abmfePendingSignedUpFansCount > 0) {
        fanSignedUpStatus = 'PROCESSING';
      }
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }

  ngOnDestroy() {
    if (this.clickEventSub) {
      this.clickEventSub.unsubscribe();
    }
    if (this.enrollStatusSubscription) {
      this.enrollStatusSubscription.unsubscribe();
    }
    if (this.accountStatusSubscription) {
      this.accountStatusSubscription.unsubscribe();
    }

    if (this.menuHideEvent) {
      this.menuHideEvent.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }
}
